// Couleur assignée par position à un collègue ajouté manuellement au
// Planning (voir plan) — un utilitaire générique, pas une donnée figée :
// s'applique à de vrais collaborateurs choisis par l'utilisateur, pas à une
// liste statique.
export const PALETTE = ["#0E7490", "#B8860B", "#7B2D8E", "#2E7D32", "#C2410C", "#1F6FEB", "#BE185D"];

export function internalEventColor(index) {
  return PALETTE[((index % PALETTE.length) + PALETTE.length) % PALETTE.length];
}
